import React from "react";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../../HeaderAll";

function HeaderVat(props) {
  const {info,infoData}=props;
  const styf = { fontWeight: "1200" };
  const styfC = { fontWeight: "500" };

  return (
    <Grid item container
      justifyContent="center"
      style={{
        fontWeight: "bold", fontFamily: "Amiri-Regular",
      }}>
      <HeaderAll Report={true} found={info} />

      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
        <Grid item xs={12} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem", paddingBottom: "0.5rem",
          borderRadius: "5px", textAlign: "center",
        }}
        >
          <div style={styf}>
            {infoData.title}
          </div>
        </Grid>
      </Grid>
      <Grid item container style={{
        fontFamily: "Amiri-Regular", padding: "0.3rem", border: "solid 2px",
        borderRadius: "5px", direction: "rtl",
      }}
      >
        <Grid item xs={12} container>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {infoData.tot4}
          </Grid>
          <Grid item xs={3} style={{ textAlign: "right" }}>
            {"الفرع"}/{" "} {infoData.branch}
          </Grid>

          <Grid item xs={3} style={{ textAlign: "right" }}>
            {"مركز التكلفة"} /{" "}   {infoData.center}
          </Grid>

          <Grid item xs={3}>
            {"تاريخ الطباعة"} {"    /"} {infoData.nDate}
          </Grid>

          <Grid item xs={3}>
            <div style={styfC}>{"من تاريخ"}{"    /"} {infoData.fDate}</div>
          </Grid>
          <Grid item xs={3}>
            <div style={styfC}> {"إلى تاريخ"}{"     /"} {infoData.tDate}</div>
          </Grid>

        </Grid>

      </Grid>
    </Grid>
  );
}
export default HeaderVat;